import { Typography } from "@mui/material";

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"© "}
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <p>米狗实业（深圳）有限公司</p>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">
        粤ICP备2022023251号
      </a>{" "}
      <p>{new Date().getFullYear()}</p>
      {"."}
    </Typography>
  );
};

export default Copyright;
